import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import { Button } from "@material-ui/core";
import { styled } from '@material-ui/styles';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Box, Tooltip, Switch } from '@mui/material';

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import { MaterialReactTable } from 'material-react-table';

const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'darkblue',
        color: 'white',
        borderColor: 'blue',
    },
}));

function novaPessoa() {
    window.location.href = "/gestao/administracao/pessoasinteresse/cadastrar";
}

export default function PessoasInteresse() {

    const [loading, setLoading] = useState(true);
    const [objetos, setObjetos] = useState([]);

    useEffect(() => {
        carregarObjetos();
    }, []);

    const carregarObjetos = async () => {
        setLoading(true);
        const token = Cookies.get('token');
        const headers = { Authorization: "Bearer " + token };
        
        try {
            const response = await api.get('/v1/protected/pessoas-interesse/listar', { headers });
            setObjetos(response.data);
        } catch (error) {
            console.error("Erro ao listar pessoas de interesse", error);
        }
        setLoading(false);
    };

    const handleBloqueioRapido = async (pessoa) => {
        const token = Cookies.get('token');
        const headers = { Authorization: "Bearer " + token };
        try {
            await api.put(`/v1/protected/pessoas-interesse/bloqueio-rapido/${pessoa.id_pessoa}`, {}, { headers });
            carregarObjetos();
        } catch (error) {
            console.error("Erro ao alterar status", error);
            alert("Erro ao alterar status.");
        }
    };
    
    const handleDeletar = async (id) => {
        if(!window.confirm("Deseja realmente deletar esta pessoa? Isso removerá todos os acessos dela.")) return;
        
        const token = Cookies.get('token');
        const headers = { Authorization: "Bearer " + token };
        try {
            await api.delete(`/v1/protected/pessoas-interesse/deletar/${id}`, { headers });
            carregarObjetos();
        } catch (error) {
            console.error("Erro ao deletar", error);
            alert("Erro ao deletar.");
        }
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id_pessoa',
                header: 'ID',
                size: 50,
            },
            {
                accessorKey: 'nome',
                header: 'Nome',
            },
            {
                accessorKey: 'cpf',
                header: 'CPF',
            },
            {
                accessorKey: 'status',
                header: 'Status',
                Cell: ({ cell }) => (
                    <span style={{ color: cell.getValue() === 1 ? 'green' : 'red', fontWeight: 'bold' }}>
                        {cell.getValue() === 1 ? 'Ativo' : 'Bloqueado'}
                    </span>
                ),
            },
        ],
        []
    );

    return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
            <NavegadorGestao BaseDados="marcado" PessoasInteresse="marcado" />

            <Grid item xs={12} sm={10} style={{ padding: '20px' }}>
                <Typography variant="h4" style={{ marginBottom: '20px' }}>
                    Pessoas de Interesse (Reconhecimento Facial)
                </Typography>

                <Box mb={2}>
                    <ColorButtonBlue variant="contained" onClick={novaPessoa}>
                        Cadastrar Pessoa Autorizada
                    </ColorButtonBlue>
                </Box>

                <MaterialReactTable
                    columns={columns}
                    data={objetos}
                    state={{ isLoading: loading }}
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip title="Editar">
                                <IconButton
                                    onClick={() => window.location.href = `/gestao/administracao/pessoasinteresse/editar/${row.original.id_pessoa}`}
                                >
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                            
                            <Tooltip title={row.original.status === 1 ? "Bloquear Acesso" : "Desbloquear Acesso"}>
                                <Switch 
                                    checked={row.original.status === 1}
                                    onChange={() => handleBloqueioRapido(row.original)}
                                    color="primary"
                                />
                            </Tooltip>
                            
                            <Tooltip title="Deletar">
                                <IconButton color="error" onClick={() => handleDeletar(row.original.id_pessoa)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}
                />
            </Grid>
        </Grid>
    );
}
